import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          קצת עליי
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          מאסטרית לאיפור קבוע וקוסמוטולוגיה מתקדמת,
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          מיקרופיגמנטציה שפתיים/גבות
          ומתמחה בעיצוב ושיקום הגבה הטבעית.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          בבעלותי שיטה חדשה ובלעדית לשזירת גבות טבעיות בשיטת הקארטין.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          בקרוב אעמיד לרשותכם טיפולי פנים ומכשור מתקדם למראה ובריאות העור.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
        היופי והאסתטיקה הובילו אותי לאורך השנים ללמוד ולהתמקצע בשיטות חדשניות מתוך אהבה למקצוע.         </p>

        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-bold px-2 text-main' dir='rtl'>
          מי שמכיר אותי יודע שאני מקפידה על דיוק, מקצועיות ואמינות, לכן אתאים לך את הטיפול המדוייק לך.                  </p>
        <p className='text-lg  font-bold max-w-md mx-auto lg:max-w-2xl rtl px-2 text-main' dir='rtl'>
          בבעלותי שתי קליניקות לשירותכם.
        </p>

        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          <span className='font-bold'>הייעוץ עליי 🤍</span>
        </p>
      </div>

    </div>

  )

}


export default About